;(function() {
  const reviews = [].slice.call(document.querySelectorAll('[data-hub-reviews]'))

  reviews.forEach(review => {
    const toggle = review.querySelector('[data-review-toggle]')
    const icon = review.querySelector('[data-review-icon]')
    const name = review.querySelector('[data-review-name]')
    const posts = review.querySelector('[data-review-posts]')

    togglePosts(posts)

    toggle.addEventListener('click', () => {
      togglePosts(posts)
      toggleExpansion(icon)
      toggleExpansion(name)
    })

    function toggleExpansion(ctrl) {
      ctrl.classList.contains('--expanded')
        ? ctrl.classList.remove('--expanded')
        : ctrl.classList.add('--expanded')
    }

    function togglePosts(post) {
      post.classList.contains('+display-none')
        ? post.classList.remove('+display-none')
        : post.classList.add('+display-none')
    }
  })
})()
